import { pushNewsletterEvent } from '@grandvisionhq/content';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../operations/mutations/signup-promotion.js';
import { SUBSCRIBE_NEWSLETTER } from '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import { useNewsletterSubmit } from './use-newsletter-submit.js';

const useSubscribeNewsletter = ()=>{
    const { locale  } = useIntl();
    const [subscribeNewsletter, { data , error: error1 , loading  }] = useMutation(SUBSCRIBE_NEWSLETTER, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        onError: (error)=>{
            console.error(`Error occurred while executing the newsletter mutation: ${error}`);
        },
        onCompleted: ()=>{
            pushNewsletterEvent({
                interactionType: 'subscription_confirm_click',
                eventName: 'newsletter_subscription_confirm'
            });
        }
    });
    const { onSubmit  } = useNewsletterSubmit(subscribeNewsletter);
    const { failures , success  } = (data === null || data === void 0 ? void 0 : data.subscribeNewsletter) || {};
    return {
        hasError: !!error1 || !!(failures === null || failures === void 0 ? void 0 : failures.length),
        hasSubscribed: success || false,
        isLoading: loading,
        onSubmit
    };
};

export { useSubscribeNewsletter };
//# sourceMappingURL=use-subscribe-newsletter.js.map
